module.exports = __webpack_public_path__ + "static/media/somalofts.53c98bcb.jpg";